import React from 'react';
export function Footer() {
  return <footer className="bg-navy-deep px-3 py-3 text-center sm:px-6" data-id="element-64" data-mp="32wd2qgad7ltj">
      <p className="mx-auto max-w-2xl text-[0.65rem] leading-relaxed text-white/60 sm:text-xs" data-id="element-65" data-mp="3gfiyquovsxjx">
        © 2026 HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™ — All Rights Reserved.
        HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™ is an educational study and
        reference resource. It does not replace formal medical education,
        supervised laboratory or clinical training, institutional protocols,
        professional medical judgment, diagnostic procedures, or
        patient-specific evaluation.
      </p>
      <p className="mt-1 text-[0.65rem] text-white/70 sm:text-xs" data-id="element-66" data-mp="3ldkcd03jg4o0">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-67" data-mp="3qcxawi3rv06f">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="29xvtajtenpsh">
          Privacy Policy
        </a>{' '}
        • Contact Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-69" data-mp="3lalhljipadw2">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}